import MaterialFormGroup, { FormGroupProps } from '@mui/material/FormGroup';

export function FormGroup(props: FormGroupProps) {
    return <MaterialFormGroup data-testid={'FormGroup-container'} {...props} />;
}

export default FormGroup;
